module.exports = __webpack_public_path__ + "img/book-bible.ea6019be.svg";